import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import SettingsAPI from '../../../api/SettingsAPI'
import {toast} from 'react-toastify'

export default function UserDetails() {
  const {id} = useParams()

  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    role_id: undefined,
    permissions: [] as any,
  })
  const [permissionList, setPermissionList] = useState<any>([])

  // init
  useEffect(() => {
    getUserById()
    getPermissionList()
  }, [])

  const getUserById = () => {
    const data = {id: id}
    SettingsAPI.getUserById(data).then(
      (res: any) => {
        if (res?.data?.success) {
          const userData = res?.data?.data
          setUser({
            name: userData.name,
            email: userData.email,
            phone: userData.phone,
            role_id: userData.role_id,
            permissions: userData.userPermissions.map((x: any) => x.permission_id),
          })
        } else {
          clearUser()
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        clearUser()
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // get permission list
  const getPermissionList = () => {
    SettingsAPI.getPermissionList().then(
      (res: any) => {
        if (res?.data?.success) {
          setPermissionList(
            res?.data?.data?.map((e: any) => {
              return {
                ...e,
                value: e?.id,
                label: e?.title,
              }
            })
          )
        } else {
          setPermissionList([])
        }
      },
      (err: any) => {
        setPermissionList([])
      }
    )
  }

  const clearUser = () => {
    setUser({
      name: '',
      email: '',
      phone: '',
      role_id: undefined,
      permissions: [],
    })
  }

  return (
    <div className='container'>
      <button
        className='bg-transparent border-0'
        onClick={() => {
          window.history.back()
        }}
      >
        <i
          className='fa fa-angle-left py-2 px-3'
          aria-hidden='true'
          style={{background: '#fff', borderRadius: '50%'}}
        ></i>{' '}
        <span className='fw-bold fs-5 px-2'>Back</span>
      </button>
      <form
        className='col-lg-9 row px-6 mx-4'
        style={{background: '#fff', marginTop: 30, borderRadius: '5px'}}
      >
        <div className='row mb-3 mt-6'>
          <div className='form-group col-lg-6'>
            <label htmlFor='fullName'>Full Name</label>
            <input type='text' className='form-control' value={user.name} disabled />
          </div>
          <div className='form-group col-lg-6'>
            <label htmlFor='email'>Email</label>
            <input type='email' className='form-control' value={user.email} disabled />
          </div>
        </div>
        <div className='row mb-3'>
          <div className='form-group col-lg-6'>
            <label htmlFor='phoneNumber'>Phone Number</label>
            <input type='text' className='form-control' value={user.phone} disabled />
          </div>
          <div className='form-group col-lg-6'>
            <label htmlFor='role'>Role</label>
            <select className='form-control form-select' value={user.role_id} disabled>
              <option value=''>Select Role</option>
              <option value={2}>Company Admin</option>
              <option value={3}>Administrator</option>
              <option value={4}>Reviewer</option>
            </select>
          </div>
        </div>
        <div className='form-group mb-2'>
          <label>Permissions</label>
          <div
            className='w-100 d-flex justify-content-between flex-wrap overflow-y-auto py-2'
            style={{height: 'auto'}}
          >
            {permissionList.map((permission: any) => (
              <div className='form-check w-lg-50 w-50 mb-2' key={permission.value}>
                <input
                  className='form-check-input'
                  id={permission.value}
                  type='checkbox'
                  checked={user.permissions.includes(permission.value)}
                  readOnly
                />
                <label className='form-check-label' htmlFor={permission.value}>
                  {permission.label}
                </label>
              </div>
            ))}
          </div>
        </div>
        {/* <div className='modal-footer'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 85}}>
                    Invite User
                    </button>
                </div> */}
      </form>
    </div>
  )
}
